import { e as ComponentsOptions, n as RegistrationActionOptions } from '../constants-e3c79897.js';

var getRegistrationAnalyticsAction = function getRegistrationAnalyticsAction(currentPage) {
  if (currentPage === ComponentsOptions.OptionsForm) {
    return RegistrationActionOptions.EmptyString;
  }
  if (currentPage === ComponentsOptions.EmailForm) {
    return RegistrationActionOptions.SignUp;
  }
  return RegistrationActionOptions.Combined;
};

export { getRegistrationAnalyticsAction as default };
//# sourceMappingURL=index.js.map
